$.module('MM.user.refreshToken', function () {
  var REFRESH_INFO = 'REFRESH_INFO';
  var refreshInfo = null;
  var refreshTimeSpan = 1000 * 60 * 60 * 6;
  var timerId = null;
  var ACTIONS = {
    getToken:
      'api/v3/oauth2/token?grant_type=refresh_token&refresh_token={refresh_token}&scope=PC_WEB',
  };

  function init() {
    registerEvent();
    initCache();
    startRefreshTimer();
    // if (MM.config.local) {
    //     refreshTimeSpan = 1000 * 60;
    // }
  }

  function startRefreshTimer() {
    clearTimeout(timerId);
    if (refreshInfo.expires_in) {
      var timeSpan = refreshInfo.expires_in - Date.now();
      if (timeSpan > 1000 * 60 * 2) {
        // token 剩余时间大于 2分钟 过期的，在最后2分钟之内随机一个时间点刷新，避免多个页面同时刷新
        var refreshTime = timeSpan - MM.common.getRangeNum(0, 60 * 2);
        MM.core.debug('startRefreshTimer refreshTime:', refreshTime);
        timerId = setTimeout(function () {
          refresh('more than 2 minutes');
        }, refreshTime);
      } else {
        if (timeSpan > 0) {
          // 2分钟之内的，立即刷新
          refresh('less 2 minutes');
        } else {
          MM.log.send({
            event: 'user',
            event_type: 'refresh_token_expired',
          });
          MM.user.clearUserInfo();
        }
      }
    }
  }

  function clear() {
    $.store.remove(REFRESH_INFO);
  }

  /**
   * 保存
   * @param {{
   *  refresh_token,
   *  expires_in,
   *  access_token
   * }} data
   */
  function save(data) {
    MM.user.setUserOriginToken(data.access_token);
    data.expires_in = data.expires_in * 1000 + new Date().getTime();
    refreshInfo = data;
    $.store.set(REFRESH_INFO, Base64.encode(JSON.stringify(data)));
  }

  function initCache(dataStr) {
    try {
      refreshInfo = JSON.parse(
        Base64.decode(dataStr || $.store.get(REFRESH_INFO)),
      );
    } catch (e) {
      clear();
      refreshInfo = {};
    }
  }

  var isRefresh = false;

  /**
   * 通过 refresh_token 获取最新的 token
   */
  function refresh(refresh_type) {
    if (isRefresh) return;
    isRefresh = true;

    if (!refreshInfo.refresh_token || !refreshInfo.expires_in) {
      return;
    }
    MM.core.debug('[refresh token] refresh()');

    request.post(
      ACTIONS.getToken,
      'amber',
      {
        scope: 'PC_WEB',
        grant_type: 'refresh_token',
        refresh_token: refreshInfo.refresh_token,
      },
      function (res) {
        MM.log.send({
          event: 'user',
          event_type: 'refresh_token_success',
          content: {
            refresh_type: refresh_type,
          },
        });
        save(res.data);
        isRefresh = false;
      },
      function (res) {
        MM.log.send({
          event: 'user',
          event_type: 'refresh_token_error',
          content: {
            res: MM.log.formatRes(res),
            refresh_type: refresh_type,
          },
        });
        MM.user.expired();
      },
    );
  }

  function registerEvent() {
    /**
     * storage 事件
     * @param {{
     *     key,
     *     oldValue,
     *     newValue,
     *     url,
     *     storageArea
     * }} e
     * @private
     */
    function _onstorage(e) {
      if (e.key === REFRESH_INFO) {
        if (e.newValue) {
          MM.core.debug('[refresh token] onstorage:', e.newValue);
          initCache(e.newValue);
          startRefreshTimer();

          if (refreshInfo.access_token) {
            MM.user.setUserOriginToken(refreshInfo.access_token);
            MM.log.send({
              event: 'user',
              event_type: 'refresh_token_sync_ok',
              content: {},
            });
          }
        } else {
          MM.log.send({
            event: 'user',
            event_type: 'refresh_token_sync_err',
            content: {},
          });
          MM.user.logout();
        }
      }
    }

    if (document.attachEvent) {
      document.attachEvent('onstorage', _onstorage);
    } else {
      window.addEventListener('storage', _onstorage, false);
    }
  }

  function get() {
    return refreshInfo;
  }

  return {
    init: init,
    clear: clear,
    save: save,
    refresh: refresh,
    get: get,
  };
});
